module.exports = __webpack_public_path__ + "img/f-thermometer-img8-3.701852f7.png";